interface VendorEnv {
  VITE_VENDOR_BASE_URL: string;
  VITE_VENDOR_WS_URL: string;
  VITE_DEFAULT_LANG: string;
  VITE_VAPID_PUBLIC_KEY: string;
}

// The build SHA / app version are no longer read here — they're injected at
// build time and exposed via `@/lib/version` (see vite.config.ts `define`).
export const env: VendorEnv = {
  VITE_VENDOR_BASE_URL: import.meta.env.VITE_VENDOR_BASE_URL ?? 'http://localhost:8013',
  VITE_VENDOR_WS_URL:
    import.meta.env.VITE_VENDOR_WS_URL ?? deriveWsUrl(import.meta.env.VITE_VENDOR_BASE_URL),
  VITE_DEFAULT_LANG: import.meta.env.VITE_DEFAULT_LANG ?? 'uz-Latn',
  VITE_VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY ?? '',
};

function deriveWsUrl(httpUrl?: string): string {
  if (!httpUrl) return 'ws://localhost:8013/ws/orders';
  const u = new URL(httpUrl);
  u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
  u.pathname = '/ws/orders';
  return u.toString();
}
